<template>
  <div class="p-d-flex p-flex-column p-ai-center p-jc-center p-pl-4 p-pr-4 p-text-center" style="height: 70vh; gap: 20px;">
    <!-- https://mia-app.it/checkout/success?session_id={CHECKOUT_SESSION_ID} -->
    <img src="assets/irinox/icons/payment_success.svg" width="200" alt="Checkout Success" class=""/>
    <h1>{{ $t('checkout.success.title') }}</h1>
    <div class="p-d-none">SESSION_ID: {{ $route.query.session_id }}</div>
    <div class="checkout-success-message">{{ $t('checkout.success.subtitle') }}</div>
    <div class="p-d-flex p-flex-column p-flex-md-row-reverse p-ai-center" style="gap: 30px; margin-top: 30px;">
      <Button class="p-mt-4" :label="$t('checkout.success.button_invoices')" @click="$router.push('/admin?tab=invoices')"></Button>
      <Button class="p-mt-4" severity="secondary" :label="$t('checkout.success.button_plans')" @click="$router.push('/admin?tab=services')"></Button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  setup() {
    // nessuna logica per ora
  },
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped>
</style>